var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83398 11.4583C1.83398 10.4458 2.6548 9.625 3.66732 9.625C5.1861 9.625 6.41732 10.8562 6.41732 12.375V16.0417C6.41732 17.5605 5.1861 18.7917 3.66732 18.7917C2.6548 18.7917 1.83398 17.9709 1.83398 16.9583V11.4583Z",
    stroke: "#04B20B",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1882 7.1559L13.944 7.94431C13.744 8.59035 13.644 8.91336 13.7209 9.16848C13.7832 9.37482 13.9198 9.55275 14.1059 9.66981C14.336 9.81446 14.6841 9.81446 15.3802 9.81446H15.7505C18.1064 9.81446 19.2844 9.81446 19.8408 10.5119C19.9043 10.5915 19.9609 10.6763 20.0098 10.7652C20.4378 11.5429 19.9512 12.5907 18.978 14.6862C18.0849 16.6092 17.6383 17.5706 16.8092 18.1366C16.729 18.1913 16.6465 18.243 16.562 18.2914C15.689 18.7918 14.6075 18.7918 12.4444 18.7918H11.9752C9.35457 18.7918 8.04427 18.7918 7.23014 18.003C6.41602 17.2142 6.41602 15.9446 6.41602 13.4054V12.5129C6.41602 11.1785 6.41602 10.5114 6.65283 9.90071C6.88964 9.29003 7.34309 8.78792 8.24998 7.78369L12.0004 3.63068C12.0945 3.52653 12.1415 3.47444 12.183 3.43835C12.5701 3.1015 13.1674 3.13942 13.5059 3.52232C13.5422 3.56334 13.5818 3.62091 13.661 3.73608C13.7849 3.91621 13.8469 4.00628 13.901 4.09551C14.3844 4.89437 14.5307 5.84333 14.3092 6.74422C14.2845 6.84484 14.2524 6.94859 14.1882 7.1559Z",
    stroke: "#04B20B",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortListIcon);
export default __webpack_public_path__ + "static/media/shortListIcon.21297793b13660ec1407f5d71da8b62f.svg";
export { ForwardRef as ReactComponent };